import script from "./FestivitiesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FestivitiesCard.vue?vue&type=script&setup=true&lang=js"

import "./FestivitiesCard.vue?vue&type=style&index=0&id=3f1c5fee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f1c5fee"]])

export default __exports__